import { cjk } from '@streamdown/cjk'
import { code } from '@streamdown/code'
import { Streamdown } from 'streamdown'

/** Keep in sync with admin-frontend/src/components/release-notes/WhatsNewMarkdown.tsx */
export const WHATS_NEW_MARKDOWN_CLASSNAME =
	'prose prose-sm dark:prose-invert max-w-none text-left text-foreground [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_h2]:mt-0 [&_h2]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_h3]:mt-3 [&_h3]:mb-1.5 [&_p]:my-1.5 [&_ul]:my-1 [&_ol]:my-1 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-4 [&_ol]:pl-4 [&_ul]:space-y-0 [&_ol]:space-y-0 [&_li]:my-0 [&_li]:py-0 [&_li]:leading-snug [&_li>p]:my-0'

type WhatsNewMarkdownProps = {
	children: string
}

export function WhatsNewMarkdown({ children }: WhatsNewMarkdownProps) {
	if (!children.trim()) {
		return <p className="text-sm text-muted-foreground italic">No content yet.</p>
	}

	return (
		<Streamdown className={WHATS_NEW_MARKDOWN_CLASSNAME} plugins={{ code, cjk }}>
			{children}
		</Streamdown>
	)
}
